export interface TenantIntegrationApiOutput {
    businessEmail?: string
    businessName?: string
    clientSecret: string
    connectedAccountId: string
    id: string
    integrationId: string
    locationId: string
    locationName?: string
}

export type TenantIntegrationApiInput = Omit<TenantIntegrationApiOutput, 'id'>

export interface TenantIntegration {
    business_email?: string
    business_name?: string
    client_secret: string
    connected_account_id: string
    id: string
    integration: {
        id: string
    }
    location: {
        id: string
        name?: string
    }
}

export function denormalizePaymentIntegration(p: TenantIntegrationApiOutput) {
    return ({
        id: p.id,
        business_email: p.businessEmail,
        business_name: p.businessName,
        client_secret: p.clientSecret,
        connected_account_id: p.connectedAccountId,
        integration: {
            id: p.integrationId,
        },
        location: {
            id: p.locationId,
            name: p.locationName
        },
    }) as TenantIntegration
}